import axios from 'axios';
import { apiUrl } from '../constants/global';

const api = axios.create({
  baseURL: `${apiUrl}`,
});

// Request interceptor
api.interceptors.request.use((config) => {
  const lang = localStorage.getItem('I18N_LANGUAGE') || 'en';
  const token = localStorage.getItem('token');

  //  Language
  config.params = {
    ...config.params,
    lang: lang,
  };

  //  Token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default api;
